import {LevelType} from "./Tools";

//LevelType = 'free' | 'silver' | 'gold' | 'platinum' | 'super' | 'unverified';

export const LEVEL_IMAGE_SEARCH: LevelType = 'silver';
export const LEVEL_IMPORT_EXPORT: LevelType = 'silver';
export const LEVEL_TEMP_SEARCH: LevelType = 'gold';
export const LEVEL_GOOGLE_MAP: LevelType = 'super';
export const LEVEL_ADD_AIRLINE: LevelType = 'silver';
export const LEVEL_EMAIL_IMPORT: LevelType = 'gold';

export const SILVER_MAPS = [0,4,5,6,8,9,10,11,16,17];
